import React from 'react';

const CustomSearch = ({ filterText, onFilter }) => {
  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <input
        type="text"
        placeholder="Search..."
        value={filterText}
        onChange={onFilter}
        style={{
          padding: '10px 40px 10px 10px',
          marginBottom: '10px',
          border: '1px solid hsl(0, 0%, 80%)',
          borderRadius: '4px',
          fontSize: '14px',
          height: '75%',
          width: '100%',
        }}
      />
      <span
        style={{
          position: 'absolute',
          top: '35%',
          right: '10px',
          transform: 'translateY(-50%)',
          pointerEvents: 'none',
        }}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_2810_11385)">
            <path
              d="M8.5 16C12.6421 16 16 12.6421 16 8.5C16 4.35786 12.6421 1 8.5 1C4.35786 1 1 4.35786 1 8.5C1 12.6421 4.35786 16 8.5 16Z"
              stroke="#11CDEF"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.9998 18.9998L13.7998 13.7998"
              stroke="#11CDEF"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_2810_11385">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </span>
    </div>
  );
};

export default CustomSearch;
